export class FileManager {
    private allowedExtensions: string[];
    constructor(allowedExtensions: string[] = []) {
        this.allowedExtensions = [];
        for (const extension of allowedExtensions) {
            this.allowedExtensions.push(extension.toLowerCase());
        }
    }

    getFileExtension(file: string): string {
        return file.toLowerCase().substr(file.lastIndexOf('.') + 1).split('.')[0];
    }

    isAllowedFileExtension(file: File): boolean {
        if (!file) { return false; }
        return this.allowedExtensions.includes(this.getFileExtension(file.name));
    }
}
